import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const FeedTrickManage: AppRouteModule = {
  path: '/feedTrickManage',
  name: 'FeedTrickManage',
  identify: 'feedTrickManage',
  component: LAYOUT,
  redirect: '/feedTrickManage/feedTrickManageIndex',
  meta: {
    icon: 'icon-park-outline:volume-notice',
    title: '话术管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'feedTrickManageIndex',
      name: 'FeedTrickManageIndex',
      identify: 'feedTrickManage',
      component: () => import('@/views/feedTrickManage/feedTrickPage/index.vue'),
      meta: {
        title: '话术管理',
        hideMenu: true,
        hideTab: true,
        roles: [RoleEnum.OFFLINE],
        currentActiveMenu: '/feedTrickManage',
      },
    },
    {
      path: 'feedTrickAdd/:pageType/:scriptId?',
      name: 'FeedTrickAdd',
      identify: 'feedTrickManage',
      component: () => import('@/views/feedTrickManage/feedTrickPage/add.vue'),
      meta: {
        title: '发布话术',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/feedTrickManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'feedTrickDetails',
      name: 'FeedTrickDetails',
      identify: 'feedTrickManage',
      component: () => import('@/views/feedTrickManage/feedTrickPage/details.vue'),
      meta: {
        title: '话术详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/feedTrickManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default FeedTrickManage;
